import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import parse from 'html-react-parser';
import { Tree, Row, Col } from "antd";
import releaseNotesImg from './releaseNotes.png';
import { DownOutlined } from "@ant-design/icons";
import "./style.css";

const ReleaseNotes = () => {
  const [selectedReleaseVer, setSelectedReleaseVer] = useState(null);

  const treeData = [
    { title: "Version 1.0", key: "1-0-0" },
    {
      title: "Version 2.0",
      key: null,
      children: [
        { title: "2.0.0", key: "2-0-0" },
        { title: "2.0.1", key: "2-0-1" },
        { title: "2.0.2", key: "2-0-2" },
      ]
    },
    {
      title: "Version 3.0",
      key: null,
      children: [
        { title: "3.0.0", key: "3-0-0" },
        { title: "3.0.1", key: "3-0-1" },
        { title: "3.0.2", key: "3-0-2" },
        { title: "3.0.3", key: "3-0-3" },
        { title: "3.0.4", key: "3-0-4" },
      ]
    },
    {
      title: "Version 4.0",
      key: null,
      children: [
        { title: "4.0.0", key: "4-0-0" },
        { title: "4.0.1", key: "4-0-1" },
        { title: "4.1.0", key: "4-1-0" },
        { title: "4.1.1", key: "4-1-1" },
        { title: "4.1.2", key: "4-1-2" },
        { title: "4.1.3", key: "4-1-3" },
        { title: "4.1.4", key: "4-1-4" },
        { title: "4.2.0", key: "4-2-0" },
        { title: "4.3.0", key: "4-3-0" },
        { title: "4.3.1", key: "4-3-1" },
      ]
    },
    {
      title: "Version 5.0",
      key: null,
      children: [
        { title: "5.0.0", key: "5-0-0" },
        { title: "5.1.0", key: "5-1-0" },
        { title: "5.2.0", key: "5-2-0" },
        { title: "5.3.0", key: "5-3-0" },
        { title: "5.3.1", key: "5-3-1" },
        { title: "5.4.0", key: "5-4-0" },
        { title: "5.4.1", key: "5-4-1" },
        { title: "5.4.2", key: "5-4-2" },
        { title: "5.4.3", key: "5-4-3" },
        { title: "5.4.4", key: "5-4-4" },
      ]
    },
  ];
  
  const releaseNotesData = {
    '1-0-0': `<p><b>1.0.0</b></p><p><u>Oct 01, 2023</u></p><p>This is the soft release of the CRP Menu Project website.</p><p>Updated Features:</p><ul><li>Home</li><li>About</li><li>Workshops</li><li>Team</li><li>Contact Us</li></ul>`,
    '2-0-0': `<p><b>2.0.0</b></p><p><u>Apr 01, 2024</u></p><p>This is the soft release of the CRP Menu Tool with the new Explore Practices features.</p><p>Updated Features:</p><ul><li>CRP Basics</li><li>Explore Practices</li><li>Contact Us</li></ul>`,
    '2-0-1': `<p><b>2.0.1</b></p><p><u>Aug 08, 2024</u></p><p>This is a minor update release.</p><p>Updated Features:</p><ul><li>CRP Basics</li><li>Team</li></ul>`,
    '2-0-2': `<p><b>2.0.2</b></p><p><u>Aug 14, 2024</u></p><p>This is a minor update release.</p><p>Updated Features:</p><ul><li>CRP Basics</li><li>Practice Details</li></ul>`,
    '3-0-0': `<p><b>3.0.0</b></p><p><u>Sep 23, 2024</u></p><p>This is a major update release with the new Check Eligibility features.</p><p>Updated Features:</p><ul><li>CRP Basics</li><li>Explore Practices</li><li>Practice Details</li><li>Check Eligibility</li><li>Workshops</li></ul>`,
    '3-0-1': `<p><b>3.0.1</b></p><p><u>Oct 9, 2024</u></p><p>This is a minor update release.</p><p>Updated Features:</p><ul><li>CRP Basics</li><li>Explore Practices</li><li>Check Eligibility</li><li>Team</li></ul>`,
    '3-0-2': `<p><b>3.0.2</b></p><p><u>Oct 17, 2024</u></p><p>This is a minor update release.</p><p>Updated Features:</p><ul><li>Check Eligibility</li><li>Workshops</li><li>User Account</li></ul>`,
    '3-0-3': `<p><b>3.0.3</b></p><p><u>Oct 22, 2024</u></p><p>This is a minor update release.</p><p>Updated Features:</p><ul><li>Check Eligibility</li><li>Workshops</li><li>User Registration</li></ul>`,
    '3-0-4': `<p><b>3.0.4</b></p><p><u>Oct 31, 2024</u></p><p>This is a minor update release.</p><p>Updated Features:</p><ul><li>Check Eligibility</li><li>User Account</li></ul>`,
    '4-0-0': `<p><b>4.0.0</b></p><p><u>Nov 8, 2024</u></p><p>This is a major update release with the new expansion states. New states added: Iowa.</p><p>Updated Features:</p><ul><li>About</li><li>Explore Practices</li><li>Check Eligibility</li><li>User Account</li></ul>`,
    '4-0-1': `<p><b>4.0.1</b></p><p><u>Nov 18, 2024</u></p><p>This is a minor update release.</p><p>Updated Features:</p><ul><li>Workshops</li></ul>`,
    '4-1-0': `<p><b>4.1.0</b></p><p><u>Dec 6, 2024</u></p><p>This is a major update release with the new expansion states. New states added: Indiana, Ohio.</p><p>Updated Features:</p><ul><li>CRP Basics</li><li>Explore Practices</li><li>Check Eligibility</li></ul>`,
    '4-1-1': `<p><b>4.1.1</b></p><p><u>Dec 20, 2024</u></p><p>This is a minor update release.</p><p>Updated Features:</p><ul><li>Workshops</li></ul>`,
    '4-1-2': `<p><b>4.1.2</b></p><p><u>Feb 3, 2024</u></p><p>This is a minor update release.</p><p>Updated Features:</p><ul><li>Workshops</li></ul>`,
    '4-1-3': `<p><b>4.1.3</b></p><p><u>Feb 6, 2024</u></p><p>This is a minor update release.</p><p>Updated Features:</p><ul><li>Check Eligibility</li></ul>`,
    '4-1-4': `<p><b>4.1.4</b></p><p><u>Feb 14, 2024</u></p><p>This is a minor update release.</p><p>Updated Features:</p><ul><li>Check Eligibility</li></ul>`,
    '4-2-0': `<p><b>4.2.0</b></p><p><u>Feb 21, 2025</u></p><p>This is a major update release with the new expansion states. New states added: Arkansas, Louisiana.</p><p>Updated Features:</p><ul><li>Explore Practices</li><li>Check Eligibility</li></ul>`,
    '4-3-0': `<p><b>4.3.0</b></p><p><u>Feb 26, 2025</u></p><p>This is a major update release with the new practice ranking scheme.</p><p>Updated Features:</p><ul><li>Explore Practices</li><li>Check Eligibility</li></ul>`,
    '4-3-1': `<p><b>4.3.1</b></p><p><u>Mar 4, 2025</u></p><p>This is a minor update release.</p><p>Updated Features:</p><ul><li>Explore Practices</li><li>Check Eligibility</li><li>Workshops</li></ul>`,
    '5-0-0': `<p><b>5.0.0</b></p><p><u>Jul 28, 2025</u></p><p>This is a major update release with state specific CREP initiatives and new interactive tutorial for first-time users.</p><p>Updated Features:</p><ul><li>CRP Basics</li><li>Explore Practices</li><li>Practice Details</li><li>Check Eligibility</li><li>Workshops</li><li>Team</li><li>User Account</li></ul>`,
    '5-1-0': `<p><b>5.1.0</b></p><p><u>Aug 20, 2025</u></p><p>This is a major update release with grassland and marginal pastureland rental rates for certain practices and a complete interactive tutorial for first-time users.</p><p>Updated Features:</p><ul><li>Check Eligibility</li><li>User Account</li></ul>`,
    '5-2-0': `<p><b>5.2.0</b></p><p><u>Sep 25, 2025</u></p><p>This is a major update release with an updated mobile view for field eligibility check and user portal.</p><p>Updated Features:</p><ul><li>Check Eligibility</li><li>User Account</li></ul>`,
    '5-3-0': `<p><b>5.3.0</b></p><p><u>Dec 8, 2025</u></p><p>This is a major update release with the new options for pin dropping and field selection on the map.</p><p>Updated Features:</p><ul><li>Check Eligibility</li></ul>`,
    '5-3-1': `<p><b>5.3.1</b></p><p><u>Jan 12, 2026</u></p><p>This is a minor update release with the new signup type filter for CRP practices.</p><p>Updated Features:</p><ul><li>Explore Practices</li><li>Check Eligibility</li></ul>`,
    '5-4-0': `<p><b>5.4.0</b></p><p><u>Jan 21, 2026</u></p><p>This is a major update release with the new payment estimate and incentives information for eligible CRP practices.</p><p>Updated Features:</p><ul><li>Check Eligibility</li></ul>`,
    '5-4-1': `<p><b>5.4.1</b></p><p><u>May 22, 2026</u></p><p>This is a minor update release with user session timeout and accessibility improvements along with team update.</p><p>Updated Features:</p><ul><li>Team</li><li>User Account</li></ul>`,
    '5-4-2': `<p><b>5.4.2</b></p><p><u>May 28, 2026</u></p><p>This is a minor update release with an update on upcoming webinars.</p><p>Updated Features:</p><ul><li>Workshops</li></ul>`,
    '5-4-3': `<p><b>5.4.3</b></p><p><u>Aug 3, 2026</u></p><p>This is a minor update release with an update on past webinar recordings and bug fixes.</p><p>Updated Features:</p><ul><li>Explore Practices</li><li>Workshops</li></ul>`,
    '5-4-4': `<p><b>5.4.4</b></p><p><u>Aug 12, 2026</u></p><p>This is a minor update release with an update on team members and small language changes.</p><p>Updated Features:</p><ul><li>Check Eligibility</li><li>Team</li></ul>`,
  };

  const onSelect = (selectedKeys) => {
    if (selectedKeys[0]) {
      setSelectedReleaseVer(releaseNotesData[selectedKeys[0]]);
    }
  };

  return (
    <div className="release-notes-container">
      <Row justify="center">
        <Col xs={22} md={20} className="mt-3">
          <h3 className="mt-3" style={{ textAlign: "center" }}>
            CRP Menu Tool - Release notes
          </h3>
          <p className="mt-3">
            We're thrilled to announce the soft release of this new CRP Menu Tool!
            Please see below for the milestones and released features:
          </p>
        </Col>
      </Row>

      {/* Grid container with gutter spacing for mobile layouts */}
      <Row justify="center" gutter={[16, 24]} className="release-content-row">
        {/* Versions Tree Panel */}
        <Col xs={22} md={6} lg={5}>
          <h3 className="releaseTreeTitle">Versions:</h3>
          <div className="tree-wrapper">
            <Tree
              className="releaseTree"
              showLine
              switcherIcon={<DownOutlined />}
              defaultExpandedKeys={["0-0-0"]}
              onSelect={onSelect}
              treeData={treeData}
            />
          </div>
        </Col>

        {/* Notes Description Display Panel */}
        <Col xs={22} md={14} lg={15}>
          {selectedReleaseVer ? (
            <div className="releaseNotesDesc">{parse(selectedReleaseVer)}</div>
          ) : (
            <div className="releaseNotesPlaceholder">
              <p>Select a version version from the tree list to view full details.</p>
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ReleaseNotes;